import React, {Fragment} from 'react';
import CategoryList from "./CategoryList";
import {Autocomplete} from "@react-google-maps/api";
import Slider from "react-rangeslider";
import {SCHEMA_MAP, SCHEMA_LIST} from "../Const";

const initialState = {
    filter: {
        locationIsSet: false,
        placeholder: 'Bitte Standort eingeben.',
        lat: null,
        lng: null,
        radius: 50,
        sort: null,
        categories: []
    }
}

class FilterDesktop extends React.Component {

    static defaultProps = {
        filter: {
            radius: 50
        },
        open: true,
        categories: [],
        members: [],
        schema: SCHEMA_MAP,
        onSelectCategory: (event) => {},
        onSelectPlace: (place) => {},
        onSelectFilter: () => {},
        onSliderChange: (value) => {},
        onChangeSort: (value) => {}
    }

    constructor(props) {
        super(props);

        this.state = {
            autocomplete: '',
            filter: {
                ...initialState.filter,
                radius: this.props.filter.radius,
                locationIsSet: this.props.filter.lat !== null && this.props.filter.lng !== null
            }
        };
    }

    componentDidUpdate(prevProps) {
        // Update local state when props change
        if (prevProps.filter !== this.props.filter) {
            const locationIsSet = this.props.filter.lat !== null && this.props.filter.lng !== null;
            const wasLocationSet = prevProps.filter.lat !== null && prevProps.filter.lng !== null;

            this.setState({
                // Autocomplete-Text leeren wenn Standort-Filter entfernt wurde
                autocomplete: (wasLocationSet && !locationIsSet) ? '' : this.state.autocomplete,
                filter: {
                    ...this.state.filter,
                    radius: this.props.filter.radius,
                    locationIsSet: locationIsSet
                }
            });
        }
    }

    onLoadAutocomplete = (autocomplete) => {
        this.autocomplete = autocomplete
    }

    handleSchemaChange = (event, schema) => {
        event.preventDefault();
        this.props.onSchemaChange(schema);
    }

    handleSelectCategory = (event) => {
        this.props.onSelectFilter();
        this.props.onSelectCategory(event);
    }

    handleSelectPlace = (filter, place) => {
        this.setState({
            autocomplete: place.formatted_address,
            filter: {
                ...this.state.filter,
                locationIsSet: true
            }
        });
        this.props.onSelectFilter();
        this.props.onSelectPlace(filter);
    }

    handleSliderChange = (dist) => {
        this.props.onSliderChange(dist);
    }

    handleSliderChangeComplete = () => {
        this.props.onSliderChangeComplete();
    }

    handleGeoPosition = (event) => {
        event.preventDefault();
        this.setState({
            filter: {
                ...this.state.filter,
                locationIsSet: true,
                placeholder: 'Standort'
            }
        });

        this.props.handleGeoPosition(event);
    }

    removeAutocomplete = (event) => {
        event.preventDefault();
        this.setState({
            autocomplete: '',
            filter: {
                ...this.state.filter,
                locationIsSet: false,
                placeholder: initialState.filter.placeholder
            }
        });

        this.props.removeGeoPosition(event);
    }

    render() {

        const {
            categories,
            members,
            schema,
            onChangeSort,
            filter
        } = this.props;

        return (
            <Fragment>
                <div className="filter">
                    <div className="infobox-1">
                        <h2>Wonach suchen Sie?</h2>
                        <p>Filtern Sie anhand Ihres Standorts oder wählen Sie einen Fachbereich.</p>
                    </div>

                    <div className="infobox-button">
                        <a href="/arzt-und-kliniksuche/" className="btn-link w-100">
                            <i className="fa fa-question-circle"/> Informationen zu den Fachbereichen
                        </a>
                    </div>

                    <div className="infobox-2">
                        <h2>
                            <i className="fas fa-user-md"></i>
                            Wählen Sie einen Fachbereich?
                        </h2>

                        <CategoryList
                            filter={filter}
                            categories={categories}
                            onClick={this.handleSelectCategory}
                            className={'mb-20'}
                        />

                    </div>


                    <div className="infobox-3">
                        <h2>
                            <i className="fas fa-location-arrow"></i>
                            Suchen Sie anhand Ihres Standorts
                        </h2>
                    </div>

                    <div className="autocomplete-wrapper mb-30">
                        <Autocomplete
                            onLoad={this.onLoadAutocomplete}
                            types={['(cities)']}
                            restrictions={{
                                country: 'de'
                            }}
                            onPlaceChanged={() => {
                                const place = this.autocomplete.getPlace();
                                if (place.geometry && place.geometry.location) {
                                    const lat = place.geometry.location.lat();
                                    const lng = place.geometry.location.lng();
                                    const filter = {
                                        ...this.state.filter,
                                        lat: lat,
                                        lng: lng,
                                    };
                                    this.setState({
                                        filter: filter
                                    }, () => {
                                        this.handleSelectPlace(filter, place);
                                    })
                                }
                            }}
                        >
                            <input
                                type={'text'}
                                value={this.state.autocomplete}
                                placeholder={this.state.filter.placeholder}
                                onChange={(event) => {
                                    this.setState({
                                        autocomplete: event.target.value
                                    })
                                }}
                            />
                        </Autocomplete>
                        {
                            (this.state.filter.locationIsSet === true)
                                ?
                                <a href="#!" onClick={this.removeAutocomplete} className="autocomplete-icon"><i className="fa fa-trash"/></a>
                                :
                                <a href="#!" onClick={this.handleGeoPosition} className="autocomplete-icon"><i className="fa fa-crosshairs"/></a>
                        }

                        {
                            (this.state.filter.locationIsSet === true)
                                ?
                                <div className='slider-horizontal mb-30'>
                                    <Slider
                                        min={0}
                                        max={400}
                                        step={5}
                                        value={this.props.filter.radius}
                                        onChange={this.handleSliderChange}
                                        onChangeComplete={this.handleSliderChangeComplete}
                                    />
                                    <div className='value'>Umkreis: {this.props.filter.radius} km</div>
                                </div>
                                :
                                <div className="mb-30"/>
                        }

                        <div className="mb-30">
                            {
                                (schema === SCHEMA_MAP)
                                    ? <button onClick={(event) => this.handleSchemaChange(event, SCHEMA_LIST)}><i className="fas fa-bars" /> Zur
                                        Listenansicht</button>
                                    : <button onClick={(event) => this.handleSchemaChange(event, SCHEMA_MAP)}><i className="fa fa-map"/> Zur
                                        Kartenansicht</button>
                            }
                        </div>

                    </div>

                    {
                        (schema === SCHEMA_MAP)
                            ?
                                <Fragment>
                                    <div className="bg-box-grey">
                                        <div className="container-fluid">
                                            <div className="row">
                                                <div className="col-12 text-right">
                                                    {members.length} Mitglieder
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Fragment>
                            :
                                <Fragment />
                    }



                </div>
            </Fragment>
        )
    }
}

export default FilterDesktop;

